import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoainnovarental() {



const cardData =
{
  keyword: 'Pune to Goa Innova Rental',

  heading: 'Lotus Cab: Pune to Goa Innova Rental',

headingDescription:
  "Lotus Cabs offers premium Pune to Goa Innova Rental services for family vacations, group tours, corporate travel, airport transfers, destination weddings, weekend getaways, and one-way or round-trip journeys. Our spacious and well-maintained Toyota Innova Crysta provides a comfortable ride with ample luggage space, making long-distance travel relaxing and convenient. Driven by professional and experienced chauffeurs, every trip is safe, punctual, and hassle-free. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, and reliable customer service, Lotus Cabs ensures a smooth and enjoyable Pune to Goa Innova rental experience.",

  top: 'Top Places to Visit in Pune before Traveling to Goa with Lotus Cab',

topPlaces: [
    {
        title: "Reis Magos Fort",
        description:
            "Reis Magos Fort is a beautifully restored Portuguese fort offering stunning views of the Mandovi River and Panaji city. Its historical exhibits, impressive architecture, and tranquil surroundings make it an excellent destination for history enthusiasts and cultural explorers."
    },
    {
        title: "Cruise on the Mandovi River",
        description:
            "A Mandovi River cruise is one of Goa's most popular experiences, featuring live Goan folk performances, music, dance, delicious cuisine, and breathtaking evening views. Whether enjoyed during sunset or at night, the cruise offers a memorable way to experience Goa's vibrant culture and scenic beauty."
    },
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa's most famous beaches, known for its lively atmosphere, water sports, beach shacks, vibrant nightlife, and stunning sunsets. Visitors enjoy activities like parasailing, jet skiing, banana boat rides, delicious seafood, and live music, making it a must-visit destination for travelers of all ages."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach, often called the 'Queen of Beaches,' is Goa's largest and most popular beach. Surrounded by restaurants, cafés, shopping stalls, and resorts, it offers exciting water sports, golden sands, and a lively environment that attracts thousands of domestic and international tourists every year."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved 17th-century Portuguese fort overlooking the Arabian Sea. Famous for its historic lighthouse, impressive architecture, and breathtaking coastal views, the fort is one of Goa's most iconic landmarks and a favorite destination for history lovers and photographers."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "The Basilica of Bom Jesus is a UNESCO World Heritage Site renowned for housing the sacred relics of St. Francis Xavier. Built in Baroque architectural style, the church is one of Goa's most significant religious monuments and attracts pilgrims and heritage enthusiasts from around the world."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India's tallest and most spectacular waterfalls, cascading through the lush forests of the Western Ghats. Visitors can enjoy thrilling jeep safaris, trekking adventures, and breathtaking natural scenery, especially during the monsoon season."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort is a historic Portuguese fort famous for its panoramic views of Vagator Beach and the Arabian Sea. Popularly recognized from the Bollywood movie 'Dil Chahta Hai,' the fort is a favorite spot for sightseeing, photography, and watching mesmerizing sunsets."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is renowned for its scenic coastline, vibrant flea market, beach parties, and laid-back atmosphere. Travelers visit to enjoy live music, delicious seafood, shopping for handicrafts, and spectacular sunset views along Goa's beautiful northern coastline."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach is one of South Goa's most picturesque beaches, celebrated for its calm waters, crescent-shaped shoreline, and peaceful surroundings. Visitors can enjoy kayaking, dolphin spotting, beachside cafés, yoga retreats, and relaxing stays in charming beachfront cottages."
    },
    
],

"services": [
  {
    "name": "Pune to Goa Innova Rental",
    "description": "Book Pune to Goa Innova rental service for comfortable long-distance travel with spacious seating, professional drivers, and flexible one-way and round-trip packages."
  },
  {
    "name": "Pune to Goa Innova Cab",
    "description": "Reliable Pune to Goa Innova cab service offering premium comfort, ample luggage space, and safe intercity transportation."
  },
  {
    "name": "Pune to Goa Innova Crysta",
    "description": "Travel in luxury with Pune to Goa Innova Crysta service featuring comfortable seating, air conditioning, and smooth highway performance."
  },
  {
    "name": "Pune to Goa Innova Hire",
    "description": "Affordable Pune to Goa Innova hire service for family trips, corporate travel, and weekend vacations with experienced chauffeurs."
  },
  {
    "name": "Pune to Goa Innova Taxi",
    "description": "Convenient Pune to Goa Innova taxi service with doorstep pickup and comfortable travel for families and groups."
  },
  {
    "name": "Pune to Goa Innova Cab Booking",
    "description": "Easy Pune to Goa Innova cab booking with instant confirmation, transparent pricing, and flexible travel schedules."
  },
  {
    "name": "Pune to Goa Innova Rental Service",
    "description": "Professional Pune to Goa Innova rental service offering well-maintained vehicles for outstation and leisure travel."
  },
  {
    "name": "Pune to Goa Crysta Rental",
    "description": "Premium Pune to Goa Crysta rental service ideal for luxury travel, family vacations, and corporate trips."
  },
  {
    "name": "Pune to Goa SUV Rental",
    "description": "Book Pune to Goa SUV rental for spacious and comfortable long-distance travel with extra luggage capacity."
  },
  {
    "name": "Pune to Goa Family Innova Cab",
    "description": "Pune to Goa family Innova cab service designed for comfortable group travel with spacious seating and safe journeys."
  },
  {
    "name": "Pune to Goa Luxury Cab",
    "description": "Luxury cab service from Pune to Goa offering premium vehicles, professional chauffeurs, and superior travel comfort."
  },
  {
    "name": "Pune to Goa Outstation Innova",
    "description": "Reliable Pune to Goa outstation Innova service with flexible itineraries and comfortable long-distance travel."
  },
  {
    "name": "Pune to Goa One Way Innova",
    "description": "Affordable Pune to Goa one way Innova service allowing passengers to pay only for a single-side journey."
  },
  {
    "name": "Pune to Goa Round Trip Innova",
    "description": "Flexible Pune to Goa round trip Innova packages for holidays, business visits, and multi-day travel plans."
  },
  {
    "name": "Pune to Goa Innova Package",
    "description": "Customized Pune to Goa Innova packages with one-way, round-trip, and sightseeing options to suit every travel need."
  },
  {
    "name": "Pune to Goa Innova Fare",
    "description": "Get transparent Pune to Goa Innova fare details with clear pricing, including distance, tolls, and driver allowances."
  },
  {
    "name": "Pune to Goa Innova Price",
    "description": "Check affordable Pune to Goa Innova price options for family and group travel with no hidden charges."
  },
  {
    "name": "Pune to Goa Cab Rental",
    "description": "Pune to Goa cab rental service with premium Innova and SUV options for comfortable intercity travel."
  },
  {
    "name": "Pune to Goa Tourist Cab",
    "description": "Comfortable Pune to Goa tourist cab service for beach vacations, family trips, and holiday travel."
  },
  {
    "name": "Pune to Goa AC Innova",
    "description": "Travel comfortably with Pune to Goa AC Innova service featuring fully air-conditioned vehicles and experienced drivers."
  },
  {
    "name": "Pune to Goa 6 Seater Cab",
    "description": "Pune to Goa 6 seater cab service ideal for small groups and families seeking spacious and comfortable travel."
  },
  {
    "name": "Pune to Goa 7 Seater Cab",
    "description": "Book a Pune to Goa 7 seater cab for group travel with ample seating and luggage space for long-distance journeys."
  }
],

"tableData": [
  ["Pune to Goa Innova Rental", "Pune to Goa Innova Cab"],
  ["Pune to Goa Innova Crysta", "Pune to Goa Innova Hire"],
  ["Pune to Goa Innova Taxi", "Pune to Goa Innova Cab Booking"],
  ["Pune to Goa Innova Rental Service", "Pune to Goa Crysta Rental"],
  ["Pune to Goa SUV Rental", "Pune to Goa Family Innova Cab"],
  ["Pune to Goa Luxury Cab", "Pune to Goa Outstation Innova"],
  ["Pune to Goa One Way Innova", "Pune to Goa Round Trip Innova"],
  ["Pune to Goa Innova Package", "Pune to Goa Innova Fare"],
  ["Pune to Goa Innova Price", "Pune to Goa Cab Rental"],
  ["Pune to Goa Tourist Cab", "Pune to Goa AC Innova"],
  ["Pune to Goa 6 Seater Cab", "Pune to Goa 7 Seater Cab"]
],






"whychoose": [
  {
    "WhyChooseheading": "Comfortable Innova Journey",
    "WhyChoosedescription": "Travel from Pune to Goa in spacious and comfortable Toyota Innova vehicles."
  },
  {
    "WhyChooseheading": "Affordable Rental Pricing",
    "WhyChoosedescription": "Competitive pricing with transparent fare details and no hidden charges."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Service",
    "WhyChoosedescription": "Book an Innova for one-way drops or convenient round trips between Pune and Goa."
  },
  {
    "WhyChooseheading": "Spacious Family Vehicle",
    "WhyChoosedescription": "Perfect for families and groups with ample seating and luggage space."
  },
  {
    "WhyChooseheading": "Doorstep Pickup Service",
    "WhyChoosedescription": "Pickup available from homes, hotels, airports, and railway stations in Pune."
  },
  {
    "WhyChooseheading": "Well-Maintained AC Innova",
    "WhyChoosedescription": "Clean, sanitized, and air-conditioned vehicles for a pleasant long-distance journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers",
    "WhyChoosedescription": "Professional chauffeurs familiar with highway and ghat routes to Goa."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance",
    "WhyChoosedescription": "Dedicated support team available anytime for booking and travel assistance."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Goa Innova rental service?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Goa Innova rental services for one-way and round-trip travel with professional drivers.',
  },
  {
    question: 'What is the distance between Pune and Goa by road?',
    answer: 'The distance from Pune to Goa is approximately 440 to 460 km depending on the route selected, and the journey takes around 8 to 10 hours.',
  },
  {
    question: 'What are the charges for Pune to Goa Innova rental?',
    answer: 'The rental charges depend on the trip type, travel date, and duration. Lotus Cab provides affordable and transparent pricing for Innova rentals.',
  },
  {
    question: 'Can I book a one-way Innova from Pune to Goa?',
    answer: 'Yes, we provide one-way Pune to Goa Innova rental services at economical rates.',
  },
  {
    question: 'Which Innova models are available?',
    answer: 'We provide Toyota Innova and Innova Crysta vehicles for comfortable long-distance travel.',
  },
  {
    question: 'Is airport pickup available in Pune?',
    answer: 'Yes, Lotus Cab offers pickup services from Pune Airport, railway stations, hotels, and residential locations.',
  },
  {
    question: 'Are toll and state taxes included in the fare?',
    answer: 'Toll charges, parking fees, and state taxes are charged separately as per actuals unless specifically included in the package.',
  },
  {
    question: 'Is night travel available from Pune to Goa?',
    answer: 'Yes, we offer safe and comfortable night travel with experienced drivers for Pune to Goa journeys.',
  },
  {
    question: 'Can I book a round trip Innova rental to Goa?',
    answer: 'Yes, Lotus Cab provides flexible round-trip packages for customers planning to return from Goa to Pune.',
  },
  {
    question: 'How can I book Pune to Goa Innova Rental with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, number of passengers, and preferred Innova model to receive instant fare details and confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Patil',
    feedback: 'Our family trip to Goa became much easier with Lotus Cab. The Innova Crysta had plenty of space, and the driver ensured a comfortable journey throughout.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Neha Deshmukh',
    feedback: 'Needed a spacious vehicle for our group vacation, and Lotus Cab provided the perfect Innova rental. Punctual service and a very smooth ride to Goa.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Innova Rental",
"image": "https://lotuscab.com/assets/images/pune-to-goa-innova-rental.jpg",
"description": "Book Pune to Goa Innova Rental with Lotus Cab for comfortable, spacious, and premium outstation travel. Hire Innova and Innova Crysta cabs for one way trips, round trips, family vacations, and luxury travel with professional drivers and 24x7 taxi service.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-innova-rental"
}
};



  return (
    <div>
      


<Helmet>
  <title>Pune to Goa Innova Rental | Innova Crysta Cab Booking | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa Innova Rental with Lotus Cab for safe and comfortable outstation travel. Get Innova, Innova Crysta, and SUV cab services for one way, round trip, family trips, and luxury travel at affordable fares."
/>

<meta
 name="keywords"
 content="Pune to Goa Innova Rental, Pune to Goa Innova Cab, Pune to Goa Innova Crysta, Pune to Goa Innova Hire, Pune to Goa Innova Taxi, Pune to Goa Innova Cab Booking, Pune to Goa Innova Rental Service, Pune to Goa Crysta Rental, Pune to Goa SUV Rental, Pune to Goa Family Innova Cab, Pune to Goa Luxury Cab, Pune to Goa Outstation Innova, Pune to Goa One Way Innova, Pune to Goa Round Trip Innova, Pune to Goa Innova Package, Pune to Goa Innova Fare, Pune to Goa Innova Price"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoainnovarental;